import { deleteGoodAction, addGoodList, setGood, setGoods } from '../../action';
import { addGoodListGroup, deleteGoodGroup, setGoodGroup } from '../../action/groupgoods';
import { identityPayload, createReducer, forAction } from '../../utils';

const initialState = [];

export default createReducer(
  [
    forAction(setGoods, identityPayload),
    forAction(setGood, (state, { payload: good }) => {
      const index = state.findIndex((item) => item.id === good.id);
      const updated = [...state];
      updated[index] = { ...good };
      return updated;
    }),
    forAction(addGoodList, (state, { payload: good }) => {
      const updated = [...state, good];
      return updated;
    }),
    forAction(deleteGoodAction, (state, { payload: id }) => {
      return state.filter((item) => item.id !== id);
    }),
    forAction(addGoodListGroup, (state, { payload: good }) => {
      const updated = [...state, good];
      return updated;
    }),
    forAction(setGoodGroup, (state, { payload: good }) => {
      const index = state.findIndex((item) => item.groupId === good.groupId);
      const updated = [...state];
      updated[index] = { ...good };
      return updated;
    }),
    forAction(deleteGoodGroup, (state, { payload: id }) => {
      return state.filter((item) => {
        if (item.groupId === id) return false;
        return true;
      });
    }),
  ],
  initialState,
);
